import React from 'react';
import PropTypes from 'prop-types';
import {compose, lifecycle} from 'recompose';
import DisqusThread from './DisqusThread';

const DisqusThreadComments = ({videoId, handleNewComment, access_token}) => (
  <div className="pv3 ph4-ns ph3 overflow-scroll">
    <DisqusThread
      shortname="barmej"
      identifier={videoId}
      url={typeof window !== 'undefined' && window.location.href}
      onNewComment={handleNewComment}
      api_key="x5DubnzoklOxbc1oSeYkOoTJOc0Lww7DJ898YaO6VMYz9mSAqpuOi9NmIGBkP3Pf"
      remote_auth_s3={access_token}
    />
  </div>
);

DisqusThreadComments.propTypes = {
  videoId: PropTypes.string.isRequired,
  handleNewComment: PropTypes.func,
  access_token: PropTypes.string,
};

const enhance = compose(
  lifecycle({
    handleNewComment(comment) {
      console.log(comment.text);
    },
  }),
);

export default enhance(DisqusThreadComments);
